// TermsAndConditions.js
import React from "react";
import { termsData } from "./terms-data";
import {
  PolicyWrapper,
  Heading,
  Paragraph,
  Bold,
  List,
  ListItem,
} from "../PolicyPLain/styles";

const TermsAndConditions = ({ primaryColor, textColor, backgroundColor }) => {
  const renderContent = (content) => {
    return content.map((item, index) => {
      if (typeof item === "string") {
        const parts = item.split("**");
        return (
          <Paragraph key={index}>
            {parts.map((part, i) =>
              i % 2 === 1 ? <Bold key={i}>{part}</Bold> : part
            )}
          </Paragraph>
        );
      }
      if (item.type === "list") {
        return (
          <List key={index}>
            {item.items.map((li, liIndex) => (
              <ListItem key={liIndex}>{li}</ListItem>
            ))}
          </List>
        );
      }
      return null;
    });
  };

  return (
    <PolicyWrapper
      primaryColor={primaryColor}
      textColor={textColor}
      backgroundColor={backgroundColor}
    >
      {termsData.map((section) => (
        <section id={section.id} key={section.id}>
          <Heading primaryColor={primaryColor}>{section.heading}</Heading>
          {renderContent(section.content)}
        </section>
      ))}
    </PolicyWrapper>
  );
};

export default TermsAndConditions;
